import { StatusButton } from '@app/shared/ui/atoms/Admin/Withdrawals';
import { WithdrawalStatus } from '@app/store/slices/withdrawal/withdrawalTypes';

const STATUSES = Object.values(WithdrawalStatus);

interface StatusesSectionProps {
  status: WithdrawalStatus;
  onStatusChange: (value: WithdrawalStatus) => void;
}

export function StatusesSection({ status, onStatusChange }: StatusesSectionProps) {
  return (
    <section className="flex flex-wrap justify-center gap-2">
      {STATUSES.map((item) => (
        <StatusButton
          key={item}
          variant={item}
          active={item === status}
          onClick={() => onStatusChange(item)}
        />
      ))}
    </section>
  );
}
